const VUE_APP_TABLE = JSON.parse(process.env.VUE_APP_TABLE)
module.exports = [
  {
    path: '/customerUISetting',
    name: 'customerUISetting',
    meta: {
      label_en: 'Park Customer UI Setting',
      color: '#517FA4',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      appCube: true,
      category: '設定',
      production: true,
      title: '園區預約設定',
      group: 4,
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/visit/CustomerUISetting.vue')
  },
  {
    path: '/TicketInformation',
    name: 'TicketInformation',
    meta: {
      label_en: 'Ticket Infomation',
      color: '#517FA4',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 4,
      appCube: true,
      category: '設定',
      production: true,
      title: '園區票價設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/visit/TicketInformation.vue')
  },
  {
    path: '/restaurantBookSet',
    name: 'restaurantBookSet',
    query: { page: '預約須知' },
    meta: {
      label_en: 'Restaurant Setting',
      color: '#C78550',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 5,
      appCube: true,
      production: true,
      title: '餐廳線上預約設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurantSet/index.vue')
  },
  {
    path: '/restaurantSet',
    name: 'restaurantSet',
    query: { page: '單品列表' },
    meta: {
      label_en: 'Dish Setting',
      color: '#C78550',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 5,
      appCube: true,
      production: true,
      title: '商品設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurant/dish.vue')
  },
  {
    path: '/restaurantTableSetv2',
    name: 'restaurantTableSetv2',
    meta: {
      label_en: 'Restaurant Tables Setting',
      color: '#C78550',
      icon: 'iconRest',
      icon1: 'setting.svg',
      group: 5,
      appCube: VUE_APP_TABLE,
      production: VUE_APP_TABLE,
      title: '餐桌設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurant/TableSet.vue')
  },
  {
    path: '/restIngredients',
    name: 'restIngredients',
    meta: {
      label_en: 'Restaurant Ingredients',
      color: '#C78550',
      icon: 'iconRest',
      icon1: 'setting.svg',
      group: 5,
      appCube: false,
      production: false,
      title: '商品原料管理',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurant/ingredients/index.vue')
  },
  {
    path: '/restaurantBookSetAll',
    name: 'restaurantBookSetAll',
    meta: {
      label_en: 'Holiday Setting',
      color: '#C78550',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 5,
      appCube: true,
      production: true,
      title: '國定假日設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/restaurantSet/All.vue')
  },
  {
    path: '/posdiscountv2',
    name: 'posdiscountv2',
    component: () => import(/* webpackChunkName: "about" */ '../views/posdiscount/indexv2.vue'),
    meta: {
      label_en: 'POS Discount Setting',
      title: 'POS折扣/服務費設定',
      requiresAuth: true,
      icon1: 'setting.svg',
      icon: 'iconSetting',
      size: [40, 40],
      marginTop: 0,
      appCube: true,
      electron: true,
      production: true,
      role: ['admin', 'manager', 'employee'],
      manager: null,
      employee: null,
      color: '#8C8C8C',
      group: 7,
      nav: false,
      navGroup: '設定'
    }
  },
  {
    path: '/pointExange',
    name: 'pointExange',
    meta: {
      label_en: 'Point Exchange',
      color: '#8C8C8C',
      icon: 'iconTicket',
      icon1: 'point.svg',
      appCube: true,
      production: true,
      title: '點數兌換',
      group: 7,
      requiresAuth: true,
      manager: null,
      employee: [],
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/pointExange/index.vue')
  },
  { // 點數兌換須知
    path: '/pointExchangeSetting',
    name: 'pointExchangeSetting',
    meta: {
      label_en: 'point Exchange Setting',
      color: '#8C8C8C',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 7,
      appCube: true,
      category: '設定',
      production: true,
      title: '點數兌換須知',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import('../views/pointExange/descriptionSet.vue')
  },
  {
    path: '/printers',
    name: 'printers',
    component: () => import(/* webpackChunkName: "about" */ '../views/posdiscount/printers.vue'),
    meta: {
      label_en: 'Printers List',
      title: '出單機設定列表',
      requiresAuth: true,
      icon1: 'setting.svg',
      icon: 'iconSetting',
      size: [40, 40],
      marginTop: 0,
      appCube: true,
      electron: true,
      production: true,
      role: ['admin', 'manager', 'employee'],
      manager: null,
      employee: null,
      color: '#8C8C8C',
      group: 7,
      nav: false,
      navGroup: '設定'
    }
  },
  {
    path: '/QASetting',
    name: 'QASetting',
    meta: {
      label_en: 'LINE@ Q&A Setting',
      color: '#40526C',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 7,
      appCube: true,
      production: true,
      title: 'LINE@Q&A設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/QASettinghtml.vue')
  },
  {
    path: '/textMsgSetting',
    name: 'textMsgSetting',
    meta: {
      label_en: 'Text Message Setting',
      color: '#40526C',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 7,
      appCube: true,
      category: '設定',
      production: true,
      title: '手機簡訊管理',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/textMessageSetting.vue')
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import(/* webpackChunkName: "about" */ '../views/announcement/index.vue'),
    meta: {
      label_en: 'Announcement Setting',
      title: '系統公告設定',
      requiresAuth: true,
      icon1: 'setting.svg',
      icon: 'iconSetting',
      size: [40, 40],
      marginTop: 0,
      appCube: true,
      electron: true,
      production: true,
      role: ['admin', 'manager', 'employee'],
      manager: null,
      employee: null,
      color: '#40526C',
      group: 7,
      nav: false,
      navGroup: '設定'
    }
  },
  {
    path: '/permission',
    name: 'permission',
    component: () => import(/* webpackChunkName: "about" */ '../views/permission.vue'),
    meta: {
      label_en: 'Permission Setting',
      title: '權限設定',
      requiresAuth: true,
      icon1: 'setting.svg',
      icon: 'iconSetting',
      size: [40, 40],
      marginTop: 0,
      appCube: true,
      electron: true,
      production: true,
      role: ['admin', 'manager', 'employee'],
      manager: null,
      employee: null,
      color: '#40526C',
      group: 7,
      nav: false,
      navGroup: '設定'
    }
  },
  {
    path: '/ProductInformation',
    name: 'ProductInformation',
    meta: {
      label_en: 'Product Infomation',
      color: '#517FA4',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 4,
      appCube: true,
      category: '設定',
      production: true,
      title: '銷項商品設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductInformation.vue')
  },
  {
    path: '/babyFirstBirthdaySetting',
    name: 'babyFirstBirthdaySetting',
    meta: {
      label_en: 'Baby Information Setting',
      color: '#D88993',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 4,
      appCube: true,
      category: '設定',
      production: true,
      title: '周晬禮讚設定',
      requiresAuth: true,
      manager: null,
      employee: null,
      // note: 'COMMING SOON',
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/baby/FirstBirthdaySetting.vue')
  },
  {
    path: '/mapsSetting',
    name: 'mapsSetting',
    meta: {
      label_en: 'Maps Setting',
      color: '#7A8661',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      appCube: true,
      category: '設定',
      production: true,
      title: '地圖設定',
      group: 4,
      requiresAuth: true,
      manager: null,
      employee: null,
      // note: 'COMMING SOON',
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/map/setting.vue')
  },
  {
    path: '/preset',
    name: 'preset',
    meta: {
      label_en: 'KPI Setting',
      color: '#BD4B4B',
      icon: 'iconSetting',
      icon1: 'setting.svg',
      group: 4,
      appCube: true,
      category: '設定',
      production: true,
      title: '業績分類',
      requiresAuth: true,
      manager: null,
      employee: null,
      note: null,
      role: ['admin', 'manager', 'employee']
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/preset/index.vue')
  }

].map(e => { return { ...e, meta: { ...e.meta, category: '設定' } } })
